export const ContractOwnerUtil = {
  isLegalRepOrNonCustomer(contractOwner) {
    return ['LEGALREP', 'NONCUSTOMER'].includes(contractOwner.contractOwnerType)
  }
}
